import React from "react";
import "./loadingStateComp.scss";
import { loadingState, waitIconDark } from "../../../../images";
import { useWindowSize } from "react-use";
import useTheme from "../../../../components/useTheme/useTheme";

const LoadingStateComp = ({ message, isError = false }) => {
  const { width } = useWindowSize();
  const { theme } = useTheme();
  return (
    <div
      className={`loading_state_container ${
        theme === "dark" && "loading_state_container--dark-mode-act"
      }`}
    >
      <div className="img_loading_state_wrapper">
        <img
          src={theme === "dark" ? waitIconDark : loadingState}
          alt="loading"
          className="img_loading_state"
        />
      </div>
      <h3 className="heading_main_loading_state">
        {isError ? "Oops! Something went wrong" : "Please Wait..."}
      </h3>
      <h5 className="title_main_loading_state">{message}</h5>
    </div>
  );
};

export default LoadingStateComp;
